import React from "react";

import { Divider } from "./Divider";

export const FormDivider: React.FC = () => <Divider marginBottom={24} marginTop={24} />;
